
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class OrgErrorMessage extends Vue {
  @Prop({ required: true, type: Boolean })
  public isStickyWidth!: boolean;

  private onClickErrorLink(e: Event): void {
    e.preventDefault();
    e.stopImmediatePropagation();

    if (e && e.target instanceof HTMLAnchorElement) {
      window.open(e.target.href);
    }
  }

  private get orgErrorMessage(): string {
    let result: string = this.$store.getters['auth/currentLanguageErrorSupplementaryMessage'];
    const orgName: string = this.$store.getters['auth/currentLanguageOrgName'];
    const kycRequestErrorRedirectURL: string = this.$store.getters['auth/kycRequestErrorRedirectURL'] || '';

    if (!result) return '';

    // 半角・全角空白を含めた {orgName} を置換
    if (orgName && orgName !== '') {
      result = result.replace(/\{(\s|"　"|)+orgName(\s|"　"|)+\}/g, orgName);
    }

    // 半角・全角空白を含めた {errorRedirectUrl} を置換
    if (kycRequestErrorRedirectURL && kycRequestErrorRedirectURL !== '') {
      const url = new URL(kycRequestErrorRedirectURL);
      url.searchParams.set('err', '4');
      result = result.replace(/\{(\s|"　"|)+errorRedirectUrl(\s|"　"|)+\}/g, url.toString());
    }

    return result;
  }
}
